module.exports = __webpack_public_path__ + "media/images/pic/anime/badminton-back-07002595f20610ac7ab85b7c8a3da795.svg";